import React from "react";

const IFrame = ({ src, style, title, id, ...props }) => {
  return <iframe style={style} id={id} src={src} title={title} {...props}></iframe>;
};

export default React.memo(IFrame);
